import React, { Component } from 'react'
import SelectedTag from '../SelectedTag/SelectedTag';
import './styles.sass';
import Draggable from "gsap/Draggable";

export default class SelectTagList extends Component {

  constructor(props) {
    super(props);
    
    this.dragElement = React.createRef();

    this.draggable = null;
  }
  componentDidMount() {      
    this.initList()
  }

  // shouldComponentUpdate() {
  //   this.initList()
  //   return true
  // }

  initList = () => {
    this.draggable = Draggable.create(this.dragElement.current, {type:"scrollLeft", edgeResistance:0.5, throwProps:true });
  }
  
  render() {
    const { tags, labelSelection, smallSelect, callbackRemoveTag, labels } = this.props
    

    // console.log('this.draggable', this.draggable);
    
    if(this.draggable && this.draggable.length > 0){
      this.draggable[0].update()
      

    } 

    return (
      <>
      <div className={`${smallSelect ? 'small': ''} tag-selected`}>
        <div className="tag-selected-text">{labelSelection ? labelSelection : labels.filtersBox_dropdown_your_selection}</div>
          <div ref={this.dragElement} id="wrapper-tag-selected" style={{overflow: 'hidden'}}>
            <div className="tag-selected-bck">
              {
                tags != null &&
                  tags.map((group, index) => {
                    return ( 
                      <>{
                      group.map((item) => {
                        return (
                          <SelectedTag key={item.id} indexGroup={index} idTag={item.id} tagSelected={item.label}  multiSelectIndex={this.props.multiSelectIndex} callbackRemoveTag={callbackRemoveTag}></SelectedTag>
                        )
                      })}
                      </>
                    )
                  })
              }
            </div>
          </div>
      </div>
      </>
    )
  }
}
